import axios from "axios";
import { TILESAPI_BASE_URL } from "./base_urls";

const singleton = Symbol();
const singletonEnforcer = Symbol();
let searchCancelTokenSource;
let dateCancelTokenSource;

class StacInterface {
    constructor() {
        this.session = axios.create({
            baseURL: TILESAPI_BASE_URL,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': `Bearer ${localStorage.getItem("tiles_api_auth0_token")}`
            }
        });
    }

    static get instance() {
        if (!this[singleton]) {
            this[singleton] = new StacInterface(singletonEnforcer);
        }

        return this[singleton];
    }

    getCollection = (collectionID) => this.session.get(`v1/collections/${collectionID}`)
    getUpgradePlanPaymentPage = (plan, planInterval) => this.session.get(`v2/plan/upgrade/${plan}/${planInterval}`);
    getItem = (uuid) => this.session.get(`v1/stac/item/${uuid}`)
    getItemEnvelop = (uuid) => this.session.get(`v1/stac/item/${uuid}/envelop`)
    getThumbnail = (uuid) => this.session.get(`v2/STAC/assets/${uuid}/thumbnail`, { responseType: 'blob' })
    getCollectionItems = (collectionID) => this.session.get(`v1/collection_items/${collectionID}?limit=1000`)
    getCollectionItemYears = (collectionID) => this.session.get(`v1/collection_items_years/${collectionID}`)
    searchAssets = (start_date, end_date, west = -180, south = -90, east = 180, north = 90, start_offset = 0, end_offset = 50, collection_name = "mosaic") => {
        if (searchCancelTokenSource !== undefined) {
            searchCancelTokenSource.cancel()
        }

        searchCancelTokenSource = axios.CancelToken.source()

        return this.session.get(`v1/stac/items/search?start_date=${start_date}&end_date=${end_date}&west=${west}&south=${south}&east=${east}&north=${north}&start_offset=${start_offset}&end_offset=${end_offset}&collection_name=${collection_name}`
            , { cancelToken: searchCancelTokenSource.token }
        );
    }
    getItemSize = (uuid) => this.session.get(`v1/item_size/${uuid}`)
    print = (data) => this.session.post(`v1/export/prints`, data)
    crop = (data) => this.session.post(`v1/export/crops`, data)
    cropPrice = (data) => this.session.post(`v1/export/crops/prices`, data)
    cropMission = (west, south, east, north, collectionID, resolution, mission, format = "tif") => this.session.get(`v1/stac/${mission}/crop_batch?west=${west}&south=${south}&east=${east}&north=${north}&collection_id=${collectionID}&resolution=${resolution}&format=${format}`)
    cropMissionPrice = (west, south, east, north, collectionID, resolution, mission, format = "tif") => this.session.get(`v1/stac/${mission}/crop_batch/price?west=${west}&south=${south}&east=${east}&north=${north}&collection_id=${collectionID}&resolution=${resolution}&format=${format}`)
    getCropRequests = () => this.session.get(`v1/export/crops`)
    getPrintRequests = () => this.session.get(`v1/export/prints`)
    getCropPaymentLink = (id) => this.session.get(`v1/make_payment/CropRequest/${id}`)
    getDates = (west, south, east, north, collectionID = "mosaic") => {
        if (dateCancelTokenSource !== undefined) {
            dateCancelTokenSource.cancel()
        }

        dateCancelTokenSource = axios.CancelToken.source();
        return this.session.get(`v1/stac/items/dates?west=${west}&south=${south}&east=${east}&north=${north}&collection_id=${collectionID}`
            , { cancelToken: dateCancelTokenSource.token }
        );
    }
    getUserServiceUsages = () => this.session.get(`v2/services/usages`)
    getUserServiceUsageDetails = (service) => this.session.get(`v2/services/usages/${service}`)
    
    getExportableCollections = () => this.session.get('v2/STAC/collections/exportable')
    getDemonstrableCollections = () => this.session.get('v2/STAC/collections/observable')
    getAllTmsLayer = () => this.session.get(`v2/STAC/layers`)
    getTmsLayersAtPoint = (lon, lat) => this.session.get(`v2/STAC/layers/at/${lon}/${lat}`)
    getMissionInfoAtPoint = (lon, lat, mission) => this.session.get(`v2/STAC/layers/${mission}/metadata`)
    
    getObliqueTmsLayersAtPoint = (lon, lat) => this.session.get(`v2/STAC/layers/obliques/at/${lon}/${lat}`)
    
    getStreetviewLayerCaptureLocations = (layer) => this.session.get(`v2/STAC/layers/streetview/${layer}/capture_locations`)
    getStreetviewLinks = (uuid) => this.session.get(`v2/STAC/layers/streetview/${uuid}/links?radius=15`)
    getStreetviewImage = (layer, uuid, width) => this.session.get(`v2/OSG/TMS/streetview/${layer}?uuid=${uuid}&size=${width}`, { responseType: 'blob' })
    
    getUserAPIKey = () => this.session.get(`user_auth/api_key`)
    generateAPIKey = () => this.session.post(`user_auth/api_key`)
    deleteAPIKey = () => this.session.delete('user_auth/api_key')
    updateAPIKey = (userAPIKey) => this.session.put(`user_auth/api_key`, userAPIKey)
    regenerateAPIKey = () => this.session.put('user_auth/api_key/regenerate')
}
export default StacInterface